<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_DATA_EXTC_RQS_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_EXTC_TYPE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.dataExtractionTypeName"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.moduleName"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="dataExctRequestData.subModuleName"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="dataExctRequestData.dataExtractionContent"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MASS_EXTC_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-radio
              v-model="dataExctRequestData.dataExtractionBigQuantityYn"
              :disabled="true"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="dataExctRequestData.dataExtractionBigQuantityYn"
              :disabled="true"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_EXTC_BAT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.batchJobId"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_REQ_DATE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.dataExtractionRequestStartDT"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_STNRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.dataExtractionRequestStandardValue"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_RSN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="dataExctRequestData.dataExtractionRequestContent"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.dataExtractionRequestStateName"
              :readonly="true"
            />
            <sui-button
              type="button"
              class="comm_btn_border"
              @click="onPopupClick"
            >
              {{ $t("MSG_BTN_APRV_PRGS_STT") }}
            </sui-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_APRV_PRGS_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.approvalProgressStateName"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RSULT_FILE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="dataExctRequestData.dataExtractionResultFilePath"
              :readonly="true"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancelClick"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00012_P02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00012',
    },
    selectedGridRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dataExctRequestData: {
        dataExtractionTypeName: '',
        moduleName: '',
        subModuleName: '',
        dataExtractionContent: '',
        dataExtractionBigQuantityYn: '',
        batchJobId: '',
        dataExtractionRequestStartDT: '',
        dataExtractionRequestStandardValue: '',
        dataExtractionRequestContent: '',
        dataExtractionRequestStateName: '',
        dataExtractionResultFilePath: '',
        approvalProgressStateName: '',
      },
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    this.onSearch();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onSearch() {
      http.request(this.pageId, 'DTS_CMS_00042', {
        path: { 'data-extract-request-id': this.selectedGridRowData.dataExtractionRequestUid },
      }).then(res => {
        this.dataExctRequestData = res.data;
        this.dataExctRequestData.dataExtractionRequestStartDT = utils.dateformatToClient(this.dataExctRequestData.dataExtractionRequestStartDT, 'S');
      });
    },
    onCancelClick() {
      this.$emit('close');
    },
    // 팝업 호출
    onPopupClick() {
      utils.openLayerPopup('PGE_CMZ_00013', null, {
        pageInitialData: {
          taskApprovalId: this.selectedGridRowData.dataExtractionRequestApprovalId, // 단건 조회시 - 기존과 같음
        },
        size: 'xlg',
      });
    },
  },
};
</script>
<style scoped>
</style>
